import { IHome } from "./models";
import { HttpClient } from "../HttpClient";

export default class HomeHttpClient {
  static retrieve(): Promise<IHome> {
    return HttpClient.get<IHome>("home/");
  }
}
